export enum FilterItemColumnType 
{
    Unknown = "Unknown",
    Boolean = "Boolean",
    Number = "Number",
    String = "String",
    Date = "Date",
    Time = "Time",
    DateTime = "DateTime",
};